import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { useTheme } from "@material-ui/core/styles";
import {
	AreaChart,
	Area,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
} from "recharts";

import { i18n } from "../../translate/i18n";

const DailyTrendChart = ({ dailyTrend }) => {
	const theme = useTheme();

	return (
		<Paper style={{ padding: 16 }}>
			<Typography variant="h6" color="primary" gutterBottom>
				{i18n.t("dashboard.trend.title")}
			</Typography>
			<ResponsiveContainer width="100%" height={280}>
				<AreaChart data={dailyTrend || []}>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="date" tick={{ fontSize: 11 }} />
					<YAxis allowDecimals={false} />
					<Tooltip />
					<Area
						type="monotone"
						dataKey="count"
						name={i18n.t("dashboard.trend.tickets")}
						stroke={theme.palette.primary.main}
						fill={theme.palette.primary.main}
						fillOpacity={0.2}
					/>
				</AreaChart>
			</ResponsiveContainer>
		</Paper>
	);
};

export default DailyTrendChart;
